import React from 'react';
import './Spinner.css';

interface SpinnerProps {
  text?: string;
  size?: 'small' | 'medium' | 'large';
  isVisible?: boolean;
  className?: string;
  style?: React.CSSProperties;
  color?: 'primary';
  inline?: boolean;
}

const Spinner: React.FC<SpinnerProps> = ({
  text = 'Cargando...',
  size = 'medium',
  isVisible = true,
  className = '',
  style,
  color = 'primary',
  inline = false,
}) => {
  if (!isVisible) {
    return null;
  }

  const containerClasses = [
    'compensar-spinner-container',
    inline ? 'compensar-spinner-container--inline' : '',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  const contentClasses = ['compensar-spinner-content', inline ? 'compensar-spinner-content--inline' : '']
    .filter(Boolean)
    .join(' ');

  const spinnerClasses = ['compensar-spinner', inline ? 'compensar-spinner--inline' : ''].filter(Boolean).join(' ');

  return (
    <div className={containerClasses} style={style}>
      <div className={contentClasses}>
        {/* Spinner circular naranja girando */}
        <div className={spinnerClasses}></div>
      </div>
    </div>
  );
};

export default Spinner;
